module.exports = __webpack_public_path__ + "static/media/Terms_and_Conditions_Crypto.9a04241c.pdf";